<template>
    <v-container v-if="this.material" fluid class="material-container">
        <div class="name">{{ this.material.name }}</div>
        <div v-if="this.selectedContractor > 0 || !this.material.client">Διαθέσιμα: <v-chip dark :color="getMaterialQuantityColor(this.material.quantity)"><h2>{{ this.material.quantity }} </h2></v-chip></div>
        <div v-if="this.material.code">Κωδικός: {{ this.material.code }}</div>
        <div>Μονάδα Μέτρησης: {{ this.material.materialMeasurement === 'METERS' ? 'Μέτρα' : 'Τεμάχια' }}</div>
        <div v-if="this.material.client">Πελάτης: {{ this.material.client.name }}</div>
        <v-select
            v-if="this.material.client"
            v-model="selectedContractor"
            :items="material.client.contractors"
            :color="'black'"
            item-value="id"
            item-text="name"
            label="Εργολάβος"
            outlined
            @change="onContractorSelect"
            class="field-contractor"
        ></v-select>
        <div v-if="containsAny(['ROLE_ADMIN'], userRoles) && ((this.material.client && this.selectedContractor > 0) || !this.material.client)" class="quantity">
            <v-text-field
                v-if="selectedContractor"
                v-model="quantityToSet"
                label="Διαθέσιμα"
                type="text"
                :readonly="readOnly"
                :rules="rules"
                class="available-input"
            />
            <v-dialog
                v-model="dialog"
                persistent
                max-width="290"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-if="readOnly && !isNaN(quantityToSet)"
                        class="white--text"
                        color="black"
                        small
                        fab
                        @click="editQuantity"
                    >
                        <v-icon medium>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                        v-else-if="quantityToSet && !isNaN(quantityToSet) && quantityToSet >= 0"
                        v-bind="attrs"
                        v-on="on"
                        class="white--text"
                        color="green"
                        small
                        fab
                    >
                        <v-icon medium>mdi-check</v-icon>
                    </v-btn>
                    <v-btn
                        v-else
                        class="hidden-btn"
                        small
                        fab
                        disabled
                    >
                        <v-icon medium>mdi-check</v-icon>
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title class="text-h5">
                        Είστε σίγουρος/η;
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="red white--text"
                            @click="dialog = false"
                        >
                            ΑΚΥΡΩΣΗ
                        </v-btn>
                        <v-btn
                            color="black white--text"
                            @click="changeQuantity()"
                        >
                            Ναι
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </div>
        <div v-if="!containsAny(['ROLE_ADMIN'], userRoles)">
            Διαθέσιμα: {{ this.material.quantity }}
        </div>
        <alert class="alert" :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>
<script>
    import material from '@/services/material'
    import jwtUtil from '@/utils/jwtUtil'
    import Alert from '@/components/Alert'
    export default {
        components: { Alert },
        computed: {
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            }
        },
        data() {
            return {
                showAlert: false,
                type: null,
                message: null,
                readOnly: false,
                material: null,
                dialog: false,
                selectedContractor: -1,
                rules: [
                    v => (!isNaN(v)) || 'Το πεδίο θα πρέπει να είναι αριθμός',
                    v => !!(v >= 0) || 'Το πεδίο θα πρεπει να είναι μη αρνητικό'
                ],
                quantityToSet: 0
            }
        },
        created() {
            this.getMaterial()
        },
        methods: {
            getMaterialQuantityColor(totalQuantity) {
                if (totalQuantity < 10) {
                    return '#8B0000'
                } else if (totalQuantity < 15) {
                    return '#F0BC68'
                }
            },
            onContractorSelect(e) {
                this.getMaterial()
            },
            editQuantity() {
                this.readOnly = false
            },
            changeQuantity() {
                material.changeMaterialQuantity(this.material.id, this.selectedContractor, { content: parseInt(this.quantityToSet) }).then(resp => {
                    this.dialog = false
                    this.readOnly = true
                    this.setAlert('Επιτυχής καταχώρηση ποσότητας', 'success')
                    this.getMaterial()
                }).catch(() => {
                    this.dialog = false
                    this.setAlert('Κάτι δεν πήγε καλά', 'error')
                })
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            getMaterial() {
                material.getMaterial(this.$route.params.materialId, this.selectedContractor).then(resp => {
                    this.material = resp.data
                    this.readOnly = true
                    this.quantityToSet = this.material.quantity
                })
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            }
        }
    }
</script>
<style scoped>
.available-input {
    font-size: 2rem;
    font-weight: 600;
    max-width: 130px;
}
.name {
    font-weight: bold;
    font-size: calc(1vw + 2vh);
    padding-top: 5rem;
    padding-bottom: 1rem;
    text-align: center;
}

.material-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 2rem;
    height: 60vh;
    justify-content: center;
}

.quantity {
    display: flex;
    align-items: center;
    margin-left: 2rem;
}

.hidden-btn {
    visibility: hidden;
}

.alert {
    width: 100%;
}

.field-contractor {
    max-width: 350px;
    padding: 0.8rem;
}
</style>
